__turbopack_context__.v({
  "activeTab": "CoverLetterGenerator-module__YsdqRG__activeTab",
  "avoidPhrase": "CoverLetterGenerator-module__YsdqRG__avoidPhrase",
  "avoidPhrasesList": "CoverLetterGenerator-module__YsdqRG__avoidPhrasesList",
  "avoidPhrasesSection": "CoverLetterGenerator-module__YsdqRG__avoidPhrasesSection",
  "avoidReason": "CoverLetterGenerator-module__YsdqRG__avoidReason",
  "checklistCheckbox": "CoverLetterGenerator-module__YsdqRG__checklistCheckbox",
  "checklistIntro": "CoverLetterGenerator-module__YsdqRG__checklistIntro",
  "checklistItem": "CoverLetterGenerator-module__YsdqRG__checklistItem",
  "checklistItems": "CoverLetterGenerator-module__YsdqRG__checklistItems",
  "checklistSection": "CoverLetterGenerator-module__YsdqRG__checklistSection",
  "checklistText": "CoverLetterGenerator-module__YsdqRG__checklistText",
  "container": "CoverLetterGenerator-module__YsdqRG__container",
  "copiedBadge": "CoverLetterGenerator-module__YsdqRG__copiedBadge",
  "copyAllButton": "CoverLetterGenerator-module__YsdqRG__copyAllButton",
  "copyButton": "CoverLetterGenerator-module__YsdqRG__copyButton",
  "doIcon": "CoverLetterGenerator-module__YsdqRG__doIcon",
  "doTip": "CoverLetterGenerator-module__YsdqRG__doTip",
  "dontIcon": "CoverLetterGenerator-module__YsdqRG__dontIcon",
  "dontTip": "CoverLetterGenerator-module__YsdqRG__dontTip",
  "finalReminder": "CoverLetterGenerator-module__YsdqRG__finalReminder",
  "footer": "CoverLetterGenerator-module__YsdqRG__footer",
  "formatIcon": "CoverLetterGenerator-module__YsdqRG__formatIcon",
  "formatTip": "CoverLetterGenerator-module__YsdqRG__formatTip",
  "header": "CoverLetterGenerator-module__YsdqRG__header",
  "headerContent": "CoverLetterGenerator-module__YsdqRG__headerContent",
  "headerIcon": "CoverLetterGenerator-module__YsdqRG__headerIcon",
  "noteIcon": "CoverLetterGenerator-module__YsdqRG__noteIcon",
  "paragraphBlock": "CoverLetterGenerator-module__YsdqRG__paragraphBlock",
  "paragraphContent": "CoverLetterGenerator-module__YsdqRG__paragraphContent",
  "paragraphHeader": "CoverLetterGenerator-module__YsdqRG__paragraphHeader",
  "paragraphLabel": "CoverLetterGenerator-module__YsdqRG__paragraphLabel",
  "paragraphText": "CoverLetterGenerator-module__YsdqRG__paragraphText",
  "paragraphTip": "CoverLetterGenerator-module__YsdqRG__paragraphTip",
  "paragraphType": "CoverLetterGenerator-module__YsdqRG__paragraphType",
  "phrasesList": "CoverLetterGenerator-module__YsdqRG__phrasesList",
  "phrasesSection": "CoverLetterGenerator-module__YsdqRG__phrasesSection",
  "placeholderNote": "CoverLetterGenerator-module__YsdqRG__placeholderNote",
  "powerPhrase": "CoverLetterGenerator-module__YsdqRG__powerPhrase",
  "signature": "CoverLetterGenerator-module__YsdqRG__signature",
  "strikeThrough": "CoverLetterGenerator-module__YsdqRG__strikeThrough",
  "tab": "CoverLetterGenerator-module__YsdqRG__tab",
  "tabIcon": "CoverLetterGenerator-module__YsdqRG__tabIcon",
  "tabLabel": "CoverLetterGenerator-module__YsdqRG__tabLabel",
  "tabNav": "CoverLetterGenerator-module__YsdqRG__tabNav",
  "templateSection": "CoverLetterGenerator-module__YsdqRG__templateSection",
  "tipIcon": "CoverLetterGenerator-module__YsdqRG__tipIcon",
  "tipsGroup": "CoverLetterGenerator-module__YsdqRG__tipsGroup",
  "tipsGroupTitle": "CoverLetterGenerator-module__YsdqRG__tipsGroupTitle",
  "tipsList": "CoverLetterGenerator-module__YsdqRG__tipsList",
  "tipsSection": "CoverLetterGenerator-module__YsdqRG__tipsSection",
  "typebody": "CoverLetterGenerator-module__YsdqRG__typebody",
  "typeclosing": "CoverLetterGenerator-module__YsdqRG__typeclosing",
  "typeopening": "CoverLetterGenerator-module__YsdqRG__typeopening",
  "typeskills": "CoverLetterGenerator-module__YsdqRG__typeskills",
});
